<div class="flex-container">
  <div class="horizontalcard">
    <div class="esc" (click)="close()">
      <img src="assets/images/esc_logo.png">
      <span>ESC</span>
    </div>
    <div class="section">
      <div class="title">
        <span>Create a new Project</span>
      </div>
      <div style="margin-left:12%;">
        <!-- <input type="text" class="project-name" placeholder="Enter Project Name" [(ngModel)]='project.Name' (keydown)="validateSpecialChar($event)" > -->
        <input type="text" class="project-name" placeholder="Enter Project Name" [(ngModel)]='project.Name'
          (keydown)="validateSpecialChar($event)">
      </div>
      <div class="formGroupLeft">
        <div class="date-picker">
          <label style="font-size:medium;">Project Date:</label>
          <input type="date" class="date" name="dp" [placeholder]='project.ReportDate' [(ngModel)]="project.ReportDate"
            ngbDatepicker #d="ngbDatepicker">
        </div>
      </div>
      <div>
        <div class="formGroupLeft">
          <label style="font-size:medium;">Project Desc:</label>
          <textarea name="projDesc" class="project-desc" [(ngModel)]="project.Desc"></textarea>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="section middle">
      <div class="title2">
        <span>Select Type of Calculation</span>
      </div>
      <div class="formGroup">
        <!-- Modified by JW(2022-08-16): select calculation type-start -->
        <!-- <button class="cld-btn" (click)="selectCalcType('CLD')">CLD Calculation</button> -->
        <!-- <button class="astm-btn" (click)="selectCalcType('ASTM')">ASTM Calculation</button> -->
        <button id="btnCLD" class="selectedcalctype-btn" (click)="selectCalcType('CLD')">CLD Calculation</button>
        &nbsp;&nbsp;&nbsp;
        <button id="btnASTM" class="unselectedcalctype-btn" (click)="selectCalcType('ASTM')">ASTM Calculation</button>
        <!-- Modified by JW(2022-08-16): select calculation type-end -->
      </div>
    </div>
    <!-- <div class="btn-grp">
      <button class="submit-btn" (click)="save()">Create Project</button>
      <button class="skip-btn" (click)="skipName()">Skip naming</button>
      <button class="skip-btn" *ngIf="(autoSaveProject!==undefined)" (click)="restoreLastProject()">Restore last project</button>
    </div> -->
    <div class="d-flex justify-content-center p-5 w-100">
      <button class="submit-btn" (click)="save()">Create Project</button>
      <button class="skip-btn" (click)="skipName()">Skip naming</button>
      <button class="skip-btn" *ngIf="(autoSaveProject!==undefined)" (click)="restoreLastProject()">Restore last project</button>
    </div>
  </div>
</div>

<div class="d-flex justify-content-center cover-spin" *ngIf="loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>